const NETWORKS = [
  {
    id: 'mainnet',
    name: 'Mainnet',
  },
  {
    id: 'polygon',
    name: 'Polygon',
  },
]
const TYPES = [
  {
    id: 'main',
    name: 'Main',
  },
  {
    id: 'proxy',
    name: 'Proxy',
  },
]

const NETWORKS_AS_OBJECT = {}
NETWORKS.forEach(row => {
  NETWORKS_AS_OBJECT[row.id] = row.id
})

const TYPES_AS_OBJECT = {}
TYPES.forEach(row => {
  TYPES_AS_OBJECT[row.id] = row.id
})

export {
  NETWORKS,
  NETWORKS_AS_OBJECT,
  TYPES_AS_OBJECT,
  TYPES,
}
